import React, { Component } from 'react'
import TextField from 'material-ui/TextField'
import { connect } from 'react-redux'
import { api } from "../../../../../../api/index"
import PromotionVariantActionsTop from './includes/actionsTop';
import PromotionVariantActionsBottom from './includes/actionsBottom';
import axios from "axios/index";
import {config} from "../../../../../../config";
import Select from 'react-select';

class PromotionVariantSideTextAdComponent extends Component {
	constructor(props) {
		super(props);

		this.handlePositionFieldState = this.handlePositionFieldState.bind(this);

		this.state = {
			isLoadingPosts: false,
			posts: [],
		}
	}

	handlePositionFieldState(event) {

		const target = event.target;
		const name = target.name;
		const value = target.value;

		api.promotions.handlePositionFieldState( name, value, this.props.periodKey, this.props.variantKey );
	}

	render() {
		const variant = this.props.promotion.periods[this.props.periodKey].variants[this.props.variantKey];

        return (
			<div className={undefined === variant.active || true === variant.active ? 'medium-12 cell promotion__variation' : 'medium-12 cell promotion__variation promotion__variation--inactive' }>
				<PromotionVariantActionsTop handleActive={this.props.handleActive} removeVariation={this.props.removeVariation} periodKey={this.props.periodKey} variantKey={this.props.variantKey} />
				<div className="grid-x grid-margin-y grid-padding-x grid-margin-x">
					<div className="medium-6 cell">
						<label>
							Titel
							<TextField
								onChange={this.handlePositionFieldState}
								value={this.props.promotion.periods[this.props.periodKey].variants[this.props.variantKey].title}
								id={'sidetextad-' + this.props.periodKey + '-variant-' + this.props.variantKey + '-title' }
								fullWidth={true}
								name="title"
							/>
						</label>
					</div>
					<div className="medium-6 cell">
						<label>
							CTA Tekst
							<TextField
								onChange={this.handlePositionFieldState}
								value={this.props.promotion.periods[this.props.periodKey].variants[this.props.variantKey].ctatext}
								id={'sidetextad-' + this.props.periodKey + '-variant-' + this.props.variantKey + '-ctatext' }
								fullWidth={true}
								name="ctatext"
							/>
						</label>
					</div>
					<div className="medium-12 cell">
						<label>
							Tekst
							<TextField
								onChange={this.handlePositionFieldState}
								value={this.props.promotion.periods[this.props.periodKey].variants[this.props.variantKey].text}
								id={'sidetextad-' + this.props.periodKey + '-variant-' + this.props.variantKey + '-text' }
								fullWidth={true}
								name="text"
								multiLine={true}
							/>
						</label>
					</div>
                </div>
				<PromotionVariantActionsBottom
					periodKey={this.props.periodKey}
					variantKey={this.props.variantKey}
				/>

			</div>
		)
    }
}

const mapStateToProps = ( state ) => {
	return {
		promotion: state.promotion
	}
};

export default connect(mapStateToProps)(PromotionVariantSideTextAdComponent)


// WEBPACK FOOTER //
// ./src/application/components/promotions/components/types/variants/sideTextAd.js